/**
 * Do not edit directly
 */

export default "PHN2ZyBkYXRhLW5hbWU9InVwZG93biIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgMTYgMTYiPjxkZWZzPjwvZGVmcz48dGl0bGU+SWNvbjwvdGl0bGU+PHBvbHlnb24gcG9pbnRzPSI4IDMuMDkgMTAuNCA1LjUgMTEuMTEgNC43OSA4IDEuNjggNC44OSA0Ljc5IDUuNiA1LjUgOCAzLjA5Ii8+PHBvbHlnb24gcG9pbnRzPSI4IDEyLjkxIDUuNiAxMC41MSA0Ljg5IDExLjIxIDggMTQuMzIgMTEuMTEgMTEuMjEgMTAuNCAxMC41MSA4IDEyLjkxIi8+PC9zdmc+";